import { createClient } from '@supabase/supabase-js'

const SB_URL = 'https://thapqeodawxffacnljij.supabase.co'
const SB_KEY = 'sb_publishable_TZQOtUq1RwjDGBpWDb92UA_KZwAOHUS'
const sb = createClient(SB_URL, SB_KEY)

// =============================================================================
// PAGE TRANSITION
// =============================================================================
document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('page-entering')
})

document.querySelectorAll('a[href]').forEach(link => {
  const href = link.getAttribute('href')
  if (
    !href ||
    href.startsWith('#') ||
    href.startsWith('http') ||
    href.startsWith('mailto') ||
    link.target === '_blank'
  )
    return
  link.addEventListener('click', e => {
    e.preventDefault()
    document.body.classList.add('page-leaving')
    setTimeout(() => {
      window.location.href = href
    }, 300)
  })
})

// =============================================================================
// MOBILE MENU
// =============================================================================
function initMobileMenu() {
  const btn = document.getElementById('hamburgerBtn')
  const menu = document.getElementById('mobileNav')
  const overlay = document.getElementById('menuOverlay')
  const closeBtn = document.getElementById('menuClose')
  if (!btn || !menu) return
  const open = () => {
    menu.classList.add('is-open')
    btn.classList.add('is-open')
    btn.setAttribute('aria-expanded', 'true')
    document.body.style.overflow = 'hidden'
  }
  const close = () => {
    menu.classList.remove('is-open')
    btn.classList.remove('is-open')
    btn.setAttribute('aria-expanded', 'false')
    document.body.style.overflow = ''
  }
  requestAnimationFrame(() => menu.classList.add('is-ready'))

  btn.addEventListener('click', open)
  closeBtn?.addEventListener('click', close)
  overlay?.addEventListener('click', close)
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') close()
  })
}
initMobileMenu()

// =============================================================================
// SCROLL TO TOP
// =============================================================================
const scrollBtn = document.getElementById('scrollToTop')
if (scrollBtn) {
  window.addEventListener('scroll', () => {
    scrollBtn.classList.toggle('is-visible', window.scrollY > 300)
  })
  scrollBtn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  })
}

// =============================================================================
// STATE
// =============================================================================
let allReviews = []
let activeLetter = '*'
let activeCategory = 'all'
let searchQuery = ''

// =============================================================================
// FETCH
// =============================================================================
async function loadReviews() {
  const listEl = document.getElementById('reviewsList')
  const loadingEl = document.getElementById('reviewsLoading')
  const emptyEl = document.getElementById('reviewsEmpty')

  const { data, error } = await sb
    .from('reviews')
    .select(
      'id, title, summary, score, created_at, category, cover_url, banner_url',
    )
    .order('created_at', { ascending: false })

  loadingEl.hidden = true

  if (error || !data) {
    emptyEl.hidden = false
    emptyEl.querySelector('p').textContent = 'Erro ao carregar reviews.'
    return
  }

  allReviews = data
  buildAlphaFilter()
  render()
}

// =============================================================================
// ALPHA FILTER
// =============================================================================
function buildAlphaFilter() {
  const letters = [
    ...new Set(
      allReviews.map(r => r.title?.[0]?.toUpperCase()).filter(Boolean),
    ),
  ].sort()

  const container = document.getElementById('alphaFilter')
  letters.forEach(letter => {
    const btn = document.createElement('button')
    btn.className = 'reviews-listing__alpha-btn'
    btn.dataset.letter = letter
    btn.textContent = letter
    btn.setAttribute('aria-label', `Filtrar pela letra ${letter}`)
    container.appendChild(btn)
  })

  container.addEventListener('click', e => {
    const btn = e.target.closest('.reviews-listing__alpha-btn')
    if (!btn) return
    activeLetter = btn.dataset.letter
    container
      .querySelectorAll('.reviews-listing__alpha-btn')
      .forEach(b => b.classList.remove('is-active'))
    btn.classList.add('is-active')
    render()
  })
}

// =============================================================================
// TABS
// =============================================================================
document.querySelectorAll('.reviews-listing__tab').forEach(tab => {
  tab.addEventListener('click', () => {
    activeCategory = tab.dataset.cat
    document.querySelectorAll('.reviews-listing__tab').forEach(t => {
      t.classList.remove('is-active')
      t.setAttribute('aria-selected', 'false')
    })
    tab.classList.add('is-active')
    tab.setAttribute('aria-selected', 'true')
    render()
  })
})

// =============================================================================
// SEARCH
// =============================================================================
document.getElementById('searchInput').addEventListener('input', e => {
  searchQuery = e.target.value.trim().toLowerCase()
  render()
})

// =============================================================================
// RENDER
// =============================================================================
function render() {
  const listEl = document.getElementById('reviewsList')
  const emptyEl = document.getElementById('reviewsEmpty')

  let filtered = allReviews

  if (activeCategory !== 'all') {
    filtered = filtered.filter(r =>
      activeCategory === 'anime'
        ? r.category === 'anime'
        : r.category !== 'anime',
    )
  }

  if (activeLetter !== '*') {
    filtered = filtered.filter(
      r => r.title?.[0]?.toUpperCase() === activeLetter,
    )
  }

  if (searchQuery) {
    filtered = filtered.filter(r =>
      r.title?.toLowerCase().includes(searchQuery),
    )
  }

  emptyEl.hidden = filtered.length > 0
  listEl.innerHTML = filtered.map(r => buildCard(r)).join('')

  listEl.querySelectorAll('a[data-review-id]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault()
      document.body.classList.add('page-leaving')
      setTimeout(() => {
        window.location.href = `review.html?id=${link.dataset.reviewId}`
      }, 300)
    })
  })
}

// =============================================================================
// CARD TEMPLATE
// =============================================================================
function buildCard(r) {
  const img = r.cover_url || r.banner_url || ''
  const date = r.created_at
    ? new Date(r.created_at).toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: 'short',
      })
    : ''
  const categoryLabel = r.category === 'anime' ? 'Anime & Mangá' : 'Jogo'
  const score = r.score != null ? Number(r.score).toFixed(1) : null
  const comment = r.summary
    ? r.summary.length > 120
      ? r.summary.slice(0, 120) + '…'
      : r.summary
    : ''

  return `
    <li class="reviews-listing__card">
      <a href="review.html?id=${r.id}" data-review-id="${
        r.id
      }" class="reviews-listing__card-link">
        <div class="reviews-listing__card-cover">
          ${
            img
              ? `<img src="${img}" alt="${r.title || ''}" loading="lazy" />`
              : '<div class="reviews-listing__card-cover--placeholder"></div>'
          }
        </div>
        <div class="reviews-listing__card-body">
          <div class="reviews-listing__card-meta">
            <span class="reviews-listing__card-category">${categoryLabel}</span>
            ${
              date
                ? `<span class="reviews-listing__card-date">${date}</span>`
                : ''
            }
          </div>
          <h2 class="reviews-listing__card-title">${r.title || '—'}</h2>
          ${
            comment
              ? `<p class="reviews-listing__card-comment">${comment}</p>`
              : ''
          }
          ${
            score != null
              ? `<p class="reviews-listing__card-score" aria-label="Nota ${score}"><span>${score}</span></p>`
              : ''
          }
        </div>
      </a>
    </li>
  `
}

loadReviews()
